import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Bundled rather than linked. The console's content security policy allows
// styles and fonts from its own origin only, so a Google Fonts link would be
// blocked and Inter would never load; vite emits the woff2 next to the bundle.
import '@fontsource-variable/inter'
// The redesign's two further faces, bundled for the same reason: Inter Tight
// for numbers and headings of 20px and above, IBM Plex Mono for references and
// timestamps. Only the weights the kit sets are imported, and each face's
// unicode ranges mean a browser fetches only the scripts a page actually uses.
import '@fontsource-variable/inter-tight'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

// # WHY THIS IMPORT IS ABOVE THE ONE FOR App
//
// Modules are evaluated depth first in import order, so importing App first
// pulled in every sheet App imports (phase1, shell, refine, depth) and left
// app.css to be evaluated after all of them. app.css was therefore the LAST
// stylesheet in the bundle, winning every tie against the sheets written to
// correct it, and refine.css, whose whole purpose is to be a set of
// corrections loaded last, was in fact loaded first.
//
// Nothing about the sheets changed. The order they were always meant to have
// is now the order they get, which is why several fixes that had to reach for
// extra specificity did.
import './styles/app.css'

import App from './App'
// After App, so the kit's sheet is the last in the bundle. Its classes all
// start kit- and restyle nothing else, so being last only settles ties against
// the global element rules for the kit's own pieces.
import './components/kit/kit.css'
// Last of all: glass and depth for every shared surface, from the tokens in
// app.css. It sets no layout, only how a surface is drawn, and settles ties
// against every sheet above.
import './styles/glass.css'
import { applyTheme, readTheme } from './lib/theme'

// Before anything is drawn, so a chosen theme never flashes the other one.
applyTheme(readTheme())

const host = document.getElementById('root')
if (!host) throw new Error('index.html is missing the #root element the console mounts into')

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
